/**
 * Halaman pertama saat aplikasi dibuka.
 *
 * Dulu: ada token → 'dashboard', untuk siapa pun. Dashboard hanya punya tampilan
 * untuk peserta, trainer, dan admin; pemilik platform jatuh ke tampilan bawaan di
 * akhir App.renderPage, yaitu dashboard PESERTA — kartu pretest dan posttest
 * untuk orang yang bukan peserta. Hanya muncul saat tab baru dibuka atau halaman
 * dimuat ulang; login biasa mengarahkannya ke 'platform' lewat pickLandingPage.
 *
 * Akun yang wajib 2FA tetapi belum mendaftar langsung ke layar pendaftaran,
 * bukan menunggu API menjawab 403 lalu dialihkan.
 *
 * @param {string|null} token  access token tersimpan
 * @param {{role?: string, mfaSetupRequired?: boolean}|null} user  pengguna tersimpan
 */
export function halamanAwal(token, user) {
  if (!token) return 'login'
  if (user?.mfaSetupRequired) return 'mfa-setup'
  if (user?.role === 'PLATFORM_OWNER') return 'platform'
  return 'dashboard'
}
